import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DetectedDevice, DeviceDetection, MacSerialNumber } from '@shure/cloud/shared/models/devices';

// This is a convenience type so that we can use the same table display for claim results for both
// local claiming and claiming by mac/serial. The key here is the important fields need to be within
// a `device` attribute in the object. Plus, I'm adding the `id` attribute for uniqueness in the
// results table.
export type MacSerialNumberDevice = { device: Pick<DetectedDevice, 'id' | 'macAddress' | 'serialNumber'> };
export type DeviceClaimMethods =
	| 'ClaimByTokenOnLocalNetwork'
	| 'ClaimByMacSerialSingle'
	| 'ClaimByMacSerialCsv'
	| 'ClaimByQrCode';

@Injectable()
export class AddDevicesDialogService {
	public deviceDiscoveryMethod$ = new BehaviorSubject<DeviceClaimMethods | undefined>(undefined);
	public detectedClaimableDevices$ = new BehaviorSubject<DeviceDetection[]>([]);
	public macSerialNumbersToClaim$ = new BehaviorSubject<MacSerialNumberDevice[]>([]);
	public macSerialNumbers: MacSerialNumber[] = [];

	constructor() {
		this.deviceDiscoveryMethod$.next(undefined);
		this.setDetectedClaimableDevices([]);
		this.setMacSerialNumbersToClaim([]);
	}

	public setClaimByTokenLocalNetwork(): void {
		this.deviceDiscoveryMethod$.next('ClaimByTokenOnLocalNetwork');
	}

	public setDetectedClaimableDevices(devices: DeviceDetection[]): void {
		this.detectedClaimableDevices$.next(devices);
	}

	public setMacSerialNumbersToClaim(devices: MacSerialNumberDevice[]): void {
		this.macSerialNumbersToClaim$.next(devices);
	}

	public setClaimByMacSerialNumberSingle(macSerialNumbers: MacSerialNumber[]): void {
		this.deviceDiscoveryMethod$.next('ClaimByMacSerialSingle');
		this.macSerialNumbers = macSerialNumbers;
	}

	public setClaimByMacSerialNumberCsv(macSerialNumbers: MacSerialNumber[]): void {
		this.deviceDiscoveryMethod$.next('ClaimByMacSerialCsv');
		this.macSerialNumbers = macSerialNumbers;
	}

	public setClaimByQrCode(): void {
		this.deviceDiscoveryMethod$.next('ClaimByQrCode');
	}
}
